import React from "react";
import { BadgeCheckIcon, StarIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { testimonials } from "../../data/content";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-289" data-mp="1ru3bt3inoev1">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-290" data-mp="1muiboprr20gq" data-mpi={i} />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-sand px-5 py-16 sm:py-24" data-id="element-291" data-mp="1dv3n5vv57zyv">
      <div className="mx-auto max-w-5xl" data-id="element-292" data-mp="18wjw5h1ozxzn">
        <SectionHeading eyebrow="Social proof" title={<>What professionals are <em className="text-gold-600" data-id="element-294" data-mp="13yigl63h6gsx">saying</em></>} data-id="element-293" data-mp="18xbugzmoc9tm" />
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-295" data-mp="13ztggutsv4er">
          <span className="font-serif text-4xl font-extrabold text-navy-900" data-id="element-296" data-mp="33ab3ub0go7sg">4.9</span>
          <div data-id="element-297" data-mp="2yct2b5orwuuh">
            <Stars data-id="element-298" data-mp="2yc9ljsav0ci1" />
            <p className="mt-0.5 text-sm font-semibold text-muted" data-id="element-299" data-mp="2y9nio5ywyl65">out of 5 · verified buyers</p>
          </div>
        </div>

        <ul className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-300" data-mp="1y8glw70lq3ju">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-301" data-mp="1jcisgwi2bdbb">
              <Stars data-id="element-302" data-mp="1oa0styi0kk7p" />
              <p className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-303" data-mp="1oblpbtnw2d87">“{t.quote}”</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-304" data-mp="2bzv44bmoq0pu">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-gold-400" data-id="element-305" data-mp="2gz7yrijssc2z" />
                <div data-id="element-306" data-mp="22b3e4916pqhk">
                  <p className="flex items-center gap-1 font-bold text-ink" data-id="element-307" data-mp="229jvibs233cm">
                    {t.name}
                    <BadgeCheckIcon className="h-4 w-4 text-success" aria-label="Verified" data-id="element-308" data-mp="277tvczoq6s4k" />
                  </p>
                  <p className="text-sm text-muted" data-id="element-309" data-mp="2uww93wg8o0ts">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-310" data-mp="39m7nkizpnvsf">
          <CTAButton label="I want to use the system" data-id="element-311" data-mp="39kwkkle3as2d" />
        </div>
      </div>
    </section>;
}